import React from "react";
import { Link } from "react-router-dom";
import { useApp } from "../context/AppContext";
import ProductCard from "../components/ProductCard";

export default function Home() {
  const { products, currentUser } = useApp();
  const recent = products.filter(p => !p.sold).slice(0, 6);

  return (
    <div>
      {/* Hero */}
      <div style={s.hero}>
        <div style={s.heroInner}>
          <h1 style={s.heroTitle}>
            El mercado de <span style={{color:"#1D9E75"}}>tu comunidad</span>
          </h1>
          <p style={s.heroSub}>Compra y vende entre miembros de la comunidad judia de forma simple y segura.</p>
          <div style={s.heroBtns}>
            <Link to="/catalog" style={s.btnPrimary}>Ver catalogo</Link>
            {!currentUser && <Link to="/register" style={s.btnSecondary}>Quiero vender</Link>}
            {currentUser && <Link to="/new-product" style={s.btnSecondary}>+ Publicar</Link>}
          </div>
        </div>
      </div>

      {/* Recientes */}
      <div style={s.section}>
        <div style={s.sectionHeader}>
          <h2 style={s.sectionTitle}>Publicaciones recientes</h2>
          <Link to="/catalog" style={s.seeAll}>Ver todo →</Link>
        </div>
        {recent.length === 0 ? (
          <p style={{color:"#888",fontSize:14}}>Todavia no hay productos.</p>
        ) : (
          <div style={s.grid}>
            {recent.map(p => <ProductCard key={p.id} product={p} />)}
          </div>
        )}
      </div>

      {/* Como funciona */}
      <div style={s.howSection}>
        <h2 style={s.sectionTitle}>Como funciona?</h2>
        <div style={s.steps}>
          {[
            {icon:"📸", title:"1. Publicás", text:"Subi fotos, precio, color, cantidad y elegí como cobrar."},
            {icon:"💬", title:"2. Te contactan", text:"Los compradores te escriben por la plataforma."},
            {icon:"💰", title:"3. Cobras", text:"Recibi el pago una vez confirmada la entrega."},
          ].map(step => (
            <div key={step.title} style={s.step}>
              <div style={{fontSize:32,marginBottom:8}}>{step.icon}</div>
              <p style={{fontWeight:600,fontSize:14,marginBottom:4}}>{step.title}</p>
              <p style={{fontSize:13,color:"#666",lineHeight:1.5}}>{step.text}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

const s = {
  hero:{background:"linear-gradient(135deg,#E1F5EE 0%,#f0fff8 100%)",padding:"48px 20px",display:"flex",alignItems:"center",justifyContent:"center",gap:32},
  heroInner:{maxWidth:520},
  heroTitle:{fontSize:34,fontWeight:700,color:"#111",lineHeight:1.2,marginBottom:14},
  heroSub:{fontSize:16,color:"#555",lineHeight:1.6,marginBottom:24},
  heroBtns:{display:"flex",gap:12,flexWrap:"wrap"},
  btnPrimary:{background:"#1D9E75",color:"#fff",padding:"12px 24px",borderRadius:10,fontWeight:500,fontSize:15,textDecoration:"none"},
  btnSecondary:{background:"#fff",color:"#1D9E75",border:"1.5px solid #1D9E75",padding:"12px 24px",borderRadius:10,fontWeight:500,fontSize:15,textDecoration:"none"},
  section:{maxWidth:1100,margin:"0 auto",padding:"36px 20px"},
  sectionHeader:{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:20},
  sectionTitle:{fontSize:20,fontWeight:600,color:"#111"},
  seeAll:{fontSize:14,color:"#1D9E75",textDecoration:"none"},
  grid:{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(200px,1fr))",gap:16},
  howSection:{background:"#fafafa",padding:"40px 20px",textAlign:"center"},
  steps:{display:"flex",gap:24,justifyContent:"center",flexWrap:"wrap",marginTop:28},
  step:{background:"#fff",border:"0.5px solid #e0e0e0",borderRadius:12,padding:"24px 20px",maxWidth:240},
};

